import { render } from "./ContainerFluidex.vue?vue&type=template&id=78e2fd03&scoped=true"
import script from "./ContainerFluidex.vue?vue&type=script&lang=js"
export * from "./ContainerFluidex.vue?vue&type=script&lang=js"

import "./ContainerFluidex.vue?vue&type=style&index=0&id=78e2fd03&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e2fd03"]])

export default __exports__